import axios from "axios";
// import config from './config/config'
import store from "./store/index";

const instance = axios.create({});

// Declarando rota default
// instance.defaults.baseURL = config.apiURL
instance.defaults.baseURL = process.env.VUE_APP_URL;

// Interceptando requisição
instance.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  config.headers.common["Authorization"] = `Bearer ${token}`;
  return config;
});

// Interceptando resposta
instance.interceptors.response.use(
  (response) => {
    localStorage.setItem("token", response.headers.authorization);
    return response;
  },
  (error) => {
    store.state.errorMessage =
      error.response?.data?.error || "Erro desconhecido";

    if (error.response?.status === 401) {
      window.location.href = "/";
    }

    return Promise.reject(error.response?.data);
  }
);

export default instance;
